import React, { useState, useRef, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { getListTicket, updateDataSearch } from "../../../actions/Ticket";
import { Headersubfull } from "../../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { useSelector, useDispatch } from "react-redux";
import { TableDanhSach } from "./TableDanhSach";
import { DongBoLichSuBtn } from "./DongBoLichSuBtn";

import giaodichBankApi from "service/TichHopBank/lichSuGiaoDichBankApi";
import LayoutV2 from "containers/LayoutV2";

export const LichSuGiaoDich = () => {
  const dispatch = useDispatch();
  const [giaodichBank, setGiaoDichBank] = useState({});
  const dataSearch = useSelector((state) => state.dataSearchLichSuBank);
  useEffect(() => {
    document.title = "Lịch sử giao dịch | Phần mềm quản lý cầm đồ Morman";
    onSearch();
  }, []);
  const onSearch = () => {
    giaodichBankApi
      .list({
        sSoTaiKhoan: dataSearch.sSoTaiKhoan,
        iPageSize: dataSearch.iPageSize,
        iPageIndex: dataSearch.iPageIndex,
        TuNgay: dataSearch.TuNgay,
        DenNgay: dataSearch.DenNgay,
      })
      .then((response) => {
        if (response.status == "200") {
          setGiaoDichBank(response.data);
        } else {
        }
      });
  };
  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new hidden-mobile-main show-table-main">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div class="row header">
                        <img
                          className="icon-bred-home"
                          src="/app-assets/images/logo-tragop-v2.png"
                          alt=""
                        />
                        <h1 className="text-info-home">Lịch sử giao dịch</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
              <div className="card-body card-body-v2">
                <SearchBarDesktop onSearch={onSearch} />
              </div>
            </div>
            <DongBoLichSuBtn data={""} onSearch={onSearch} />
            <SearchBarMobile onSearch={onSearch} />
    
          </div>
        </div>
        <TableDanhSach dataDanhSach={giaodichBank} onSearch={onSearch} />
      </div>
    </LayoutV2>
  );
};
